<template>
  <div style="padding-bottom: 10px">
    <div class="imgAndSearch">
      <!-- 轮播图 start-->
      <div class="data-rotation">
        <div style="height:300px">
          <img src="@/assets/images/zhuanshiBanner.jpg" alt="">
        </div>
      </div>
      <!-- 轮播图 end-->
    </div>
    <div>
      <div class="contentBox">
        <div class="latest">
          <div>
            <div style="font-weight: 600;">家的<span
                style="color: #EB5139">服务</span></div>
            <div class="settled" @click="goAuthenticationcertification">
              申请加入注安师之家
            </div>
          </div>
          <div>
            <div>
              <div>
                官网专属宣传
              </div>
              <div>
                展示个人风采、提升个人曝光度
              </div>
            </div>
            <div>
              <div>
                专属海报
              </div>
              <div>
                微信群、朋友圈、客户覆盖式推送
              </div>
            </div>
            <div>
              <div>
                注安师之家证书
              </div>
              <div>
                颁发专属ID的注安师之家成员证书
              </div>
            </div>
            <div>
              <div>
                提供学习平台
              </div>
              <div>
                免费提供注安师能力提升课程。
              </div>
            </div>
            <div>
              <div>
                提供文献资料
              </div>
              <div>
                免费提供注安师工作所需材料。
              </div>
            </div>
            <div>
              <div>
                提供行业资讯
              </div>
              <div>
                免费提供安全生产相关行业资讯。
              </div>
            </div>
            <div>
              <div>
                工作机会对接
              </div>
              <div>
                协助对接企业注安师岗位需求。
              </div>
            </div>
            <div>
              <div>
                平台晋升通道
              </div>
              <div>
                为注安师提供晋升讲师专家通道。
              </div>
            </div>
            <div>
              <div>
                会议论坛交流
              </div>
              <div>
                择机组织会议论坛交流学习。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sortBox">
        <div class="Recommended">
          <div>
            <div style="font-weight: 600;">家的<span
                style="color: #EB5139">成员</span></div>
            <div @click="getMoreTeacher">更多></div>
          </div>
          <div>
            <div v-for="(item) in teacherList" :key="item.id" @click="goDetail(item)">
              <!--                            <el-image style="width: 80px;height: 80px;border-radius: 50%" :src="item.picture"-->
              <!--                                      fit="cover"></el-image>-->
              <div
                  :style="{width: '80px',height: '80px',borderRadius: '50%',backgroundImage: 'url(' + item.picture + ')',backgroundSize: 'cover',backgroundPosition: 'center 10%'}"></div>
              <div>
                <div>{{ item.name }}</div>
                <div>{{ item.title }}</div>
                <div>{{ item.industryType }}</div>
                <div><i class="el-icon-location" style="margin-right: 3px"></i>{{ item.city }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentAll">
        <div class="topBox">
          <div>
            <div>
              <div style="font-weight: 600;font-size: 18px">行业<span
                  style="color: #EB5139">资讯</span></div>
              <div @click="goMoreNew">更多></div>
            </div>
            <div>
              <div v-for="(item) in messageList" :key="item.id" @click="goNewsDeatils(item.id)">
                <div></div>
                <div>{{ item.messageTitle }}</div>
                <div>{{ timestampToTime(item.releaseTime) }}</div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div style="font-weight: 600;font-size: 18px">行业<span
                  style="color: #EB5139">会议</span></div>
              <div @click="goMoreMeet">更多></div>
            </div>
            <div>
              <div v-for="(item) in mettingList" :key="item.id" @click="goMeetingDetail(item)">
                <div></div>
                <div>{{ item.title }}</div>
                <div>{{ timestampToTime(item.holdingTime) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomBox">
          <div>
            <div>
              <div style="font-weight: 600;font-size: 18px">安全<span
                  style="color: #EB5139">规章</span></div>
              <div @click="goMoreRegula">更多></div>
            </div>
            <div>
              <div v-for="(item) in regulationList" :key="item.id" @click="goDocumentDetail(item)">
                <div></div>
                <div>{{ item.relusTitle }}</div>
                <div>{{ timestampToTime(item.releaseTime) }}</div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div style="font-weight: 600;font-size: 18px">事故<span
                  style="color: #EB5139">案例</span></div>
              <div @click="goMoreCase">更多></div>
            </div>
            <div>
              <div v-for="(item) in caseList" :key="item.id"
                   @click="goCaseDetail(item.id,item.isType)">
                <div></div>
                <div>{{ item.accidentName }}</div>
                <div>{{ timestampToTime(item.applyTime) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="classContent">
        <div>
          <div style="font-weight: 600;font-size: 18px">提升<span
              style="color: #EB5139">课程</span></div>
          <div @click="goMoreClass">更多></div>
        </div>
        <div>
          <div class="cla-detail">
            <ul class="classItem">
              <li
                  v-for="item in classList"
                  :key="item.id"
                  @click="goCourseDetails(item.id, item.isPay)"
              >
                <div class="imgs">
                  <img :src="item.surfacePlotUrl" alt="" class="cla-p"/>
                </div>
                <div class="title" v-html="item.headline"></div>
                <div class="information">
                  <span style="font-size: 14px" class="fl"
                  >讲师：{{ item.teacherName }}</span
                  >
                </div>
                <br/>
                <div class="times-card">
                  <div class="left">
                    <span>{{ timestampToTime(item.onlineTime) }}</span>
                  </div>
                  <div class="center"></div>
                  <div class="right">
                    <span v-if="item.isPay != 3">￥</span>
                    <i>{{ item.isPay == 3 ? "免费" : item.originalPrice }}</i>
                  </div>
                </div>
                <p class="public" v-show="item.isPay == 2">会员免费</p>
                <p class="public" v-show="item.isPay == 3">免费课程</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="convenient">
        <div style="font-weight: 600;font-size: 18px">便捷<span
            style="color: #EB5139">服务</span></div>
        <div>
          <div>
            <a href="https://www.mem.gov.cn/" class="link" target="_blank">应急管理部官网</a>
          </div>
          <div class="line"></div>
          <div>
            <a href="https://rmocse.chinasafety.ac.cn/" class="link" target="_blank">中级注册安全工程师注册管理系统</a>
          </div>
          <div class="line"></div>
          <div>
            <a href="https://www.dedaoketang.com/s/pc/#/home/index" class="link"
               target="_blank">中级注册安全工程师考前培训</a>
          </div>
          <!--                    <div class="line"></div>-->
          <!--                    <div>-->
          <!--                        <a href="https://www.china-safety.org.cn/client/index.html" class="link" target="_blank">中国安全生产协会</a>-->
          <!--                    </div>-->
          <div class="line"></div>
          <div>
            <a href="http://www.cosha.org.cn/" class="link" target="_blank">中国职业安全健康协会</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import {searchByIndustry} from "@/api/teacher";
import {getPageByType} from "@/api/news";
import {searchMetting} from "@/api/meeting";
import {getPageByTypeOrRelus} from "@/api/regulations";
import {getListPopular} from "@/api/case/caseList";
import {getCourseInfo} from "@/api/study";

export default {
  name: "FindInformation",
  data() {
    return {
      teacherList: [],
      messageList: [],
      mettingList: [],
      regulationList: [],
      caseList: [],
      classList: []
    };
  },

  mounted() {
    // 行业讯息
    getPageByType({current: 1, size: 8, type: ''}).then(res => {
      if (res.code === 200) {
        this.messageList = res.data.records
      }
    })
    // 教师
    searchByIndustry({current: 1, size: 18, keyWord: '', type: ''}).then(res => {
      if (res.code === 200) {
        this.teacherList = res.data.records
      }
    })
    // 会议
    searchMetting({current: 1, size: 8, title: ''}).then(res => {
      console.log(res)
      this.mettingList = res.data.records
    })
    //     规章
    getPageByTypeOrRelus({
      relusType: '',
      size: 8,
      current: 1,
      time: '',
      type: '',
      titleOrText: '',
      content: '',
      relusID: ''
    }).then(res => {
      if (res.code === 200) {
        this.regulationList = res.data.records
      }
    })
    //     事故案例
    getListPopular({current: 1, size: 8}).then(res => {
      if (res.code === 200) {
        this.caseList = res.data.records
      }
    })
    getCourseInfo(1, 8, 0, 0, '', 0).then(res => {
      if (res.code === 200) {
        this.classList = res.data.records
      }
    })
  },
  methods: {
    timestampToTime(time) {
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var date = new Date(time);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;
    },
    getPageByType,
    // 更多
    getMoreTeacher() {
      this.$router.push({path: '/instructorsearch'})
    },
    goMoreNew() {
      this.$router.push({path: '/news'})
    },
    goMoreMeet() {
      this.$router.push({path: '/meetingsearch'})
    },
    goMoreRegula() {
      this.$router.push({path: '/selectregulations'})
    },
    goMoreCase() {
      this.$router.push({path: '/informationsearch'})
    },
    goMoreClass() {
      this.$router.push({path: '/study'})
    },
    goAuthenticationcertification() {
      if (this.$store.state.user.userInfo.phone !== "") {
        this.$router.push("/user/Securityworkerssettlingin");
      } else {
        this.$message.error({
          title: "警告",
          message: "请先绑定手机号后再继续",
        });
      }

    },
    goDetail(item) {
      this.$router.push({
        path: "/instructordetails?id=" + item.id,
      });
    },
    goCourseDetails(id, isPay) {

      this.$router.push("/coursedetails?id=" + id + "&ispay=" + isPay);
    },
    goNewsDeatils(id) {
      this.$router.push({
        path: "/newsdetails?id=" + id,
      });
    },
    goMeetingDetail(item) {
      this.$router.push({
        path: "/meetingdetails?id=" + item.id + "&industryType=" + item.industryType,
      });
    },
    goDocumentDetail(item) {
      this.$router.push("/selectregulationsDetails/" + item.articleId);
    },
    goCaseDetail(id, type) {
      this.$router.push({
        path: `/informationdetail?id=${id}&type=${type}`,
      });
    },
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}

/* 轮播图 */
.data-rotation {
  img {
    width: 100%;
    height: 300px;
  }

  ::v-deep {
    .el-carousel__indicator--horizontal {
      padding: 30px 5px;
    }

    .el-carousel__button {
      width: 52px;
      height: 6px;
      background: #fff;
    }

    .is-active .el-carousel__button {
      background-color: #eb5139;
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      margin: 0;
    }
  }
}

/* 搜索框 */
.search {
  position: relative;
  width: 100%;
  margin: -25px auto auto;
  z-index: 2;

  > div {
    width: 700px;
    margin: auto;

    ::v-deep {
      .el-input--small {
        width: 596px;
      }

      .el-input__inner {
        height: 50px;
        border: 1px solid #EB5139;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        font-size: 16px;
      }
    }

    > button {
      padding: 13px 33px;
      font-size: 17px;
      background-color: #EB5139;
      border: 1px solid #EB5139;
      color: white;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
}

/* 内容框 */
.contentBox {
  width: 1200px;
  margin: 20px auto;
  padding: 25px;
  background-color: white;
  border-radius: 10px;
}

/* 最新内容 */
.latest {
  > div:nth-child(1) {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    > div:nth-child(1) > span {
      color: #FF6330;
    }

    > div:nth-child(2) {
      font-size: 14px;
      cursor: pointer;
    }

    .settled {
      padding: 10px;
      background-color: #EB5139;
      border-radius: 10px;
      color: #FFFFFF;
    }
  }

  > div:nth-child(2) {
    margin-top: 10px;
    display: flex;
    //align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 10px;

    > div {
      padding: 10px;
      width: 105px;
      background-color: #F5F7FA;
      border-radius: 10px;
      cursor: pointer;

      > div:nth-child(1) {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #EB5139;
      }

      > div:nth-child(2) {
        font-size: 13px;
        //color: #5a5a5a;
      }

      &:hover {
        box-shadow: 3px 5px #ededed;
      }
    }
  }
}

/* 行业推荐 */
.sortBox {
  width: 1200px;
  margin: 20px auto;
  padding: 20px 25px;
  background-color: white;
  border-radius: 10px;
}

.Recommended {
  > div:nth-child(1) {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    > div:nth-child(1) > span {
      color: #FF6330;
    }

    > div:nth-child(2) {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }

  > div:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;

    > div {
      cursor: pointer;
      display: flex;
      width: 15%;
      background-color: #F5F7FA;
      border-radius: 5px;
      padding: 10px 5px;
      margin-bottom: 15px;
      align-items: center;
      justify-content: space-between;
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);

        > div:nth-child(2) {
          > div:nth-child(1) {
            color: #EB5139;
          }
        }
      }

      &:nth-child(6n) {
        margin-right: 0;
      }

      > div:nth-child(2) {
        flex: 1;
        margin-left: 5px;

        > div:nth-child(1) {
          font-size: 16px;

          margin-bottom: 3px;
          font-weight: 600;
        }

        > div:nth-child(2) {
          color: #5a5a5a;
          margin-bottom: 3px;
        }

        > div:nth-child(3) {
          color: #777;
          margin-bottom: 3px;
        }

        > div:nth-child(4) {
          color: #888;
        }
      }
    }
  }
}

.cla-detail {
  margin-top: 10px;
}

//行业讯息
.contentAll {
  width: 1250px;
  margin: 20px auto;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
      width: 45.5%;
      padding: 20px 25px;
      background-color: white;
      border-radius: 10px;

    }
  }

  > .topBox {
    margin-bottom: 20px;

    > div {
      > div:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div:nth-child(2) {
          color: #999999;
          cursor: pointer;
        }
      }

      > div:nth-child(2) {
        margin-top: 15px;

        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          cursor: pointer;

          > div:nth-child(1) {
            height: 5px;
            width: 5px;
            border-radius: 50%;
            margin-right: 5px;
            background-color: #EB5139;
          }

          > div:nth-child(2) {
            width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            letter-spacing: 1px;
          }

          > div:nth-child(3) {
            width: 15%;
            color: #999999;
          }

          &:hover {
            > div:nth-child(2) {
              color: #EB5139;
            }
          }
        }


      }
    }
  }

  > .bottomBox {
    > div {
      > div:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div:nth-child(2) {
          color: #999999;
          cursor: pointer;
        }
      }

      > div:nth-child(2) {
        margin-top: 15px;

        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          cursor: pointer;

          > div:nth-child(1) {
            height: 5px;
            width: 5px;
            border-radius: 50%;
            margin-right: 5px;
            background-color: #EB5139;
          }

          > div:nth-child(2) {
            width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            letter-spacing: 1px;
          }

          > div:nth-child(3) {
            width: 15%;
            color: #999999;
          }

          &:hover {
            > div:nth-child(2) {
              color: #EB5139;
            }
          }
        }


      }
    }
  }
}

//课程
.classContent {
  width: 1200px;
  margin: 20px auto;
  padding: 20px 25px;
  background-color: white;
  border-radius: 10px;

  > div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div:nth-child(2) {
      cursor: pointer;
      color: #999999;
    }
  }
}

.classItem {
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}

.classItem > li {
  background-color: #ffffff;
  border-radius: 9px;
  float: left;
  margin: 0.7% 0.5% !important;
  box-shadow: 0 27px 26px #00000017;
  position: relative;
  width: 24%;
  overflow: hidden;
}

.classItem > li > .title {
  font-size: calc(100vw * 14 / 1920);
  margin: 10px;
  // margin-bottom: 20px;
  font-weight: bold;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.classItem > li > .imgs {
  background: #ccc;
  height: 148px;
  overflow: hidden;
}

.classItem > li > .imgs > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.public {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 64px;
  font-size: 12px;
  color: white;
  background-color: #e97f37;
  border-radius: 9px 0 10px 0;
  text-align: center;
  line-height: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
}

.information {
  margin: 10px;
}

.times-card {
  display: flex;
  margin: 10px;
  color: gray;
  align-items: baseline;
  justify-content: space-between;
}

.left .right {
  margin: 10px;
}

.right > i {
  font-size: 16px;
  color: #ff843f;
}

.right {
  width: 50px;
}

.convenient {
  width: 1200px;
  margin: 20px auto;
  padding: 20px 25px;
  background-color: white;
  border-radius: 10px;

  > div:nth-child(2) {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;

    > .line {
      width: 5px;
      height: 5px;
      background-color: #EB5139;
      border-radius: 10px;
      margin: 0 12px;
    }
  }

}
</style>
